import { MouseEvent } from 'react';

import { Row } from 'react-table';

import { Host } from './useHostsData/interfaces';

type HostClick = (
  event: MouseEvent,
  id: number,
  rowIndex?: number,
  flatRows?: Row<Host>[]
) => void;

export const dispatchHostClick = (
  event: MouseEvent,
  id: number,
  onClick: HostClick,
  onDoubleClick: (id: number) => void,
  rowIndex?: number,
  flatRows?: Row<Host>[]
): void => {
  if (event.detail === 2) {
    onDoubleClick(id);
    return;
  }
  onClick(event, id, rowIndex, flatRows);
};

export const useDoubleClick: (
  onClick: HostClick,
  onDbClick: (id: number) => void
) => HostClick = (onClick, onDbClick) => {
  return (event, id, rowIndex, flatRows) =>
    dispatchHostClick(event, id, onClick, onDbClick, rowIndex, flatRows);
};
